import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ClientInterface } from '../data';
import { ContractProvider } from '../providers/contract.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class GetFirstHolderUseCase implements UseCase<Observable<Transaction<ClientInterface>>> {
    constructor(private contractProvider: ContractProvider) {}

    bind(): Observable<Transaction<ClientInterface>> {
        return this.contractProvider.current().pipe(
            map((transaction) =>
                transaction.map(
                    (contract) => Transaction.success(cloneDeep(contract.holders[0])),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
